import { render, staticRenderFns } from "./SkipNavigationLink.vue?vue&type=template&id=8279d5b0&scoped=true"
import script from "./SkipNavigationLink.vue?vue&type=script&lang=js"
export * from "./SkipNavigationLink.vue?vue&type=script&lang=js"
import style0 from "./SkipNavigationLink.vue?vue&type=style&index=0&id=8279d5b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8279d5b0",
  null
  
)

export default component.exports